import * as z from "zod";

export const deleteViewFolder = {
  name: "deleteViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
